const jobPostCreation = window.location.pathname.match(/\/works\/(\d*\/edit|new)/);

if (jobPostCreation) {
  document.addEventListener('DOMContentLoaded', function() {
    const fireFighterSelected = document.getElementById("work_fire_fighter_id");
    const workInterestWrapper = document.getElementById("work_interest_wrapper");
    const workStatus = document.getElementById("work_status");

    if (fireFighterSelected && workInterestWrapper) {
      fireFighterSelected.addEventListener('change', function() {
        if(!fireFighterSelected.value) {
          workInterestWrapper.style.display = "none";
          
          workStatus.value = "pending";

          const inputs = workInterestWrapper.querySelectorAll('input');
          inputs.forEach(input => {
            input.value = '';
          });
          
          return;
        }

        workStatus.value = "assigned";

        workInterestWrapper.style.display = "block";        
      });
    }
  });
}
